import { render } from "./CanvasSelectBox.vue?vue&type=template&id=d0fe218a"
import script from "./CanvasSelectBox.vue?vue&type=script&lang=js"
export * from "./CanvasSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__